/**
 * Auth Module
 */
import Vue from 'vue'
import Persona from '@/api/persona'

const state = {
  persona: null
}

// getters
const getters = {
  persona: state => state.persona
}

// actions
const actions = {
  actualizarSeccion (context, payload) {
    const datos = payload

    datos.id = context.getters.persona.id

    return new Promise((resolve, reject) => {
      Persona.guardar(datos).then(
        data => {
          Vue.notify({
            group: 'general',
            type: 'success',
            text: 'Los datos se guardaron correctamente!'
          })
          context.commit('setearPersona', data)
          /* if (datos.item.paciente) {
            context.commit('detallePaciente/actualizar', datos.item.paciente, { root: true })
          } */
          resolve(data)
        },
        error => {
          // context.commit('loginUserFailure', error)
          reject(error)
          // }, 500)
        }
      )
    })
  }
}

// mutations
const mutations = {
  setearPersona (state, persona) {
    state.persona = persona
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
